module.exports = __webpack_public_path__ + "static/media/EasyCall-out-logo.072e29cd.svg";